var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPolygon = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: 0,
  y: 0,
  viewBox: "0 0 1024 1024"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M815.6 713.9l-88.7-266.8h40.8v-184h-184v37.5l-269.1-92.1v-95.8h-184v184h72v417.2h-72v184h184v-72h414.1v72h184v-184h-97.1zm-86.9 72H314.6v-72h-72V296.7h72v-45.9l269.1 92.1v104.2h101.1l88.7 266.8h-44.7v72z"
})));
export default SvgPolygon;